import React from "react"
import { FileRejection } from "react-dropzone"
import * as layouts from "layouts"
import * as inputs from "inputs"
import * as icons from "icons"
import Papa from "papaparse"
import { acceptedMimetypes } from "brandguard/display/unified/types"

interface props {
	onChange(item: File[]): void
	disabled?: boolean
}

// splitLines parses a CSV or plain-text file into one text/plain File per
// non-empty line so each line is scored as its own asset.
export function splitLines(file: File): Promise<File[]> {
	return new Promise((resolve) =>
		Papa.parse(file, {
			complete: (results) =>
				resolve(
					results.data
						.map((line) => (line as string[]).join(" "))
						.filter((line) => line.trim().length !== 0)
						.map((line, i) => new File([line], `${i}-${file.name}`, { type: "text/plain" })),
				),
		}),
	)
}

export default function Dropwell(
	props: React.PropsWithChildren<props> & layouts.containers.ContainerProps,
): JSX.Element {
	const { onChange, disabled, ...rest } = props
	const onDropHandle = (acceptedFiles: File[], fileRejections: FileRejection[]) => {
		if (acceptedFiles.length === 0) return
		acceptedFiles.forEach((file) => splitLines(file).then(onChange))
	}

	return (
		<inputs.Dropwell
			accept={acceptedMimetypes.text}
			onDrop={(accepted, rejected, evt) => onDropHandle(accepted, rejected)}
			flex="1"
			multiple
			disabled={disabled}
			{...rest}
		>
			<layouts.dnd.Container>
				<icons.FileUpload className="dropwell-icon" />
				<layouts.dnd.Textual>Drag & drop your file here or choose file</layouts.dnd.Textual>
			</layouts.dnd.Container>
		</inputs.Dropwell>
	)
}
